// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1276bd44","239":"dfdb0d71","453":"d855a71b","667":"27bafb85"}[chunkId] + ".chunk.js";
};